import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row row-cols-1 row-cols-md-3 g-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-text" }
const _hoisted_8 = {
  key: 0,
  class: "card-text"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "Gültig ab:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = {
  key: 1,
  class: "card-text"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "card-text"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "card-footer" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_25 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw pe-1 fa-angle-down" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("alle Kurskarten anzeigen ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Keine Kurskarten vorhanden.")
], -1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.credits.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.credits, (credit, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: credit.id,
                      class: "col"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card h-100 text-center", {'card-expired': _ctx.progressColor(credit) === 'danger'
                             || _ctx.daysUntilExpiration(credit) === -1}])
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h5", {
                            class: _normalizeClass(["card-title", _ctx.nameClass(credit)])
                          }, _toDisplayString(_ctx.nameHuman(credit)), 3),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: "progress mt-3 mb-2",
                              style: _normalizeStyle(_ctx.isProgressHidden(credit) ? 'visibility:hidden;' : '')
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["progress-bar progress-bar-stripedX", {['bg-'+_ctx.progressColor(credit)]: true, 'progress-bar-percentage-outside': (1 - _ctx.progress(credit)) < 0.15}]),
                                role: "progressbar",
                                style: _normalizeStyle('width: ' + _ctx.progressPercentage(credit)),
                                "aria-valuenow": "10",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, _toDisplayString(_ctx.progressPercentage(credit, 'round')), 7)
                            ], 4)
                          ]),
                          (credit.object === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                (_ctx.daysUntilValid(credit) !== -1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      _hoisted_10,
                                      _hoisted_11,
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatDatetime(credit.valid_at)), 1)
                                    ]))
                                  : (_ctx.daysUntilExpiration(credit) === -1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Abgelaufen. "))
                                    : (_ctx.daysUntilExpiration(credit) === 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Läuft heute ab. "))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_14, " Noch " + _toDisplayString(_ctx.daysUntilExpiration(credit)) + " Tag" + _toDisplayString(_ctx.daysUntilExpiration(credit) !== 1 ? 'e' : '') + " verbleibend. ", 1))
                              ]))
                            : (credit.object === 1)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                  (_ctx.daysUntilExpiration(credit) === -1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Abgelaufen. "))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                        (_ctx.usedAtomsCount(credit) === credit.atoms.length)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Wow, du hast alle Trainings geschafft. "))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.usedAtomsCount(credit)) + " von " + _toDisplayString(credit.atoms.length) + " Trainings aufgebraucht. ", 1))
                                      ]))
                                ]))
                              : (credit.object === 2)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                    _createTextVNode(_toDisplayString(credit.course.course_type.name), 1),
                                    _hoisted_21,
                                    _createElementVNode("small", null, _toDisplayString(credit.course.weekday_label), 1)
                                  ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("small", null, [
                            (credit.object !== 2)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_23, "Gültig bis " + _toDisplayString(_ctx.formatDatetime(credit.expires_at)) + ".", 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_24
                                ], 64))
                          ])
                        ])
                      ], 2)
                    ], 512)), [
                      [_vShow, _ctx.expanded || index < _ctx.initialVisibleCount]
                    ])
                  }), 128))
                ]),
                (!_ctx.expanded && _ctx.credits.length > _ctx.initialVisibleCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onExpand && _ctx.onExpand(...args)), ["prevent"]))
                      }, _hoisted_28)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
        ], 64))
  ]))
}